import { PaymentType } from '@/resources/enums'
import { ORDERS_HISTORY_PAGE as dict } from '@/resources/dict'

export const paymentTypeTableLabel = {
  [PaymentType.DEBIT_CARD]: dict.paymentMethods.card,
  [PaymentType.CREDIT_CARD]: dict.paymentMethods.card,
  [PaymentType.CASH]: dict.paymentMethods.cash,
  [PaymentType.ONLINE_PAYMENT]: dict.paymentMethods.onlinePayment,
  [PaymentType.PIX]: dict.paymentMethods.pix,
  [PaymentType.NUPAY]: dict.paymentMethods.nupay,
  [PaymentType.NUPAY_CREDIT]: dict.paymentMethods.nupay,
  [PaymentType.NUPAY_DEBIT]: dict.paymentMethods.nupay,
}

export const paymentTypeFilterLabel = {
  [PaymentType.DEBIT_CARD]: dict.paymentMethods.debitCard,
  [PaymentType.CREDIT_CARD]: dict.paymentMethods.creditCard,
  [PaymentType.CASH]: dict.paymentMethods.cash,
  [PaymentType.ONLINE_PAYMENT]: dict.paymentMethods.onlinePayment,
  [PaymentType.PIX]: dict.paymentMethods.pix,
  [PaymentType.NUPAY]: dict.paymentMethods.nupay,
}
